window.debounce = function (fn, time) {
  var timeout = null;
  return function() {
    if(!timeout) {
      timeout = setTimeout(function() { fn(); timeout = null; }, time);
    }
  }
}